"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _relativeLuminance = require("./relativeLuminance");
var _propTypes2 = require("@agillic/prop-types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var fontSizeToSizeRatio = 32 / 100;
var Avatar = function Avatar(_ref) {
  var size = _ref.size,
    photoUrl = _ref.photoUrl,
    userName = _ref.userName,
    userInitials = _ref.userInitials,
    backgroundColor = _ref.backgroundColor,
    shape = _ref.shape,
    uniqueID = _ref.uniqueID;
  var fontSize = Math.floor(size * fontSizeToSizeRatio);
  var shadowSize = Math.floor(size / 25 + 1);
  var avatarPadding = Math.floor(fontSize / 2);
  var foregroundColor = (0, _relativeLuminance.isColorBright)({
    color: backgroundColor || '#000000'
  }) ? 'black' : 'white';
  return _react.default.createElement("div", {
    "data-testid": uniqueID,
    className: "agillicAvatar",
    title: userName,
    style: {
      width: "".concat(size, "px"),
      height: "".concat(size, "px")
    }
  }, photoUrl ? _react.default.createElement("img", {
    className: (0, _classnames.default)('avatarImage', shape),
    src: photoUrl,
    alt: userInitials,
    width: size,
    height: size
  }) : _react.default.createElement("span", {
    className: (0, _classnames.default)('initials', shape),
    style: {
      width: "".concat(size, "px"),
      height: "".concat(size, "px"),
      lineHeight: "".concat(size, "px"),
      fontSize: "".concat(fontSize, "px"),
      padding: "0 ".concat(avatarPadding, "px"),
      boxShadow: "0 0 0 ".concat(shadowSize, "px white"),
      backgroundColor: "".concat(backgroundColor),
      color: "".concat(foregroundColor)
    }
  }, userInitials));
};
Avatar.propTypes = {
  shape: (0, _propTypes.oneOf)(['square', 'rounded', 'circle']).isRequired,
  size: _propTypes.number.isRequired,
  photoUrl: _propTypes.string,
  userName: _propTypes.string,
  userInitials: _propTypes.string,
  backgroundColor: (0, _airbnbPropTypes.and)([_propTypes.string, (0, _propTypes2.forbiddenBy)('photoUrl'), (0, _propTypes2.requiredBy)('userInitials')]),
  uniqueID: _propTypes.string.isRequired
};
Avatar.defaultProps = {
  shape: 'circle',
  size: 100
};
var _default = Avatar;
exports.default = _default;